import { useState, useEffect } from 'react';
import { Button } from '../../ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../ui/tabs';
import { Input } from '../../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Card, CardContent } from '../../ui/card';
import { ArrowLeft, Search } from 'lucide-react';
import DirectCommissionTable from './DirectCommissionTable';
import TieredCommissionTable from './TieredCommissionTable';
import SubDistributorDialog from './SubDistributorDialog';
import { userService } from '../../../_services';

function CommissionTrackingView({ onBack }) {
  // State
  const [activeTab, setActiveTab] = useState('direct');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [monthOptions, setMonthOptions] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [showSubDistDialog, setShowSubDistDialog] = useState(false);
  const [selectedDistributor, setSelectedDistributor] = useState(null);

  // Fetch month/year data on mount
  useEffect(() => {
    fetchMonthYearData();
  }, []);

  const fetchMonthYearData = async () => {
    try {
      const Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
      const [userId] = Usermeta_Data.split(':');
      const userRole = window.atob(localStorage.getItem('UserRole'));
      
      const response = await userService.GetMonthYear(userId, userRole);
      
      if (response && response.length > 0) {
        setMonthOptions(response);
        // Set first month as default
        setSelectedMonth(`${response[0].month},${response[0].year}`);
      }
    } catch (error) {
      console.error('Error fetching month/year data:', error);
    }
  };

  const handleDistributorClick = (distributor, dateMonth) => {
    setSelectedDistributor({ ...distributor, dateMonth });
    setShowSubDistDialog(true);
  };

  return (
    <div className="w-full space-y-6">
      {/* Header with Back Button */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button variant="ghost" onClick={onBack}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Reports
          </Button>
          <h1 className="text-2xl font-semibold">Commission Tracking</h1>
        </div>
      </div>

      {/* Filters Card */}
      <Card>
        <CardContent className="pt-6">
          <div className="flex gap-4">
            <Select value={selectedMonth} onValueChange={setSelectedMonth}>
              <SelectTrigger className="w-[200px]">
                <SelectValue placeholder="Select month" />
              </SelectTrigger>
              <SelectContent>
                {monthOptions.map((option, index) => (
                  <SelectItem 
                    key={index} 
                    value={`${option.month},${option.year}`}
                  >
                    {option.monthName} {option.year}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
              <Input 
                placeholder="Search by name or email..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="pl-9"
              />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Tabs with Tables */}
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="direct">Direct Commission</TabsTrigger>
          <TabsTrigger value="tiered">Tiered Commission</TabsTrigger>
        </TabsList>

        <TabsContent value="direct">
          <DirectCommissionTable
            searchText={searchText}
            selectedMonth={selectedMonth}
            onRowClick={handleDistributorClick}
          />
        </TabsContent>

        <TabsContent value="tiered">
          <TieredCommissionTable
            searchText={searchText}
            selectedMonth={selectedMonth}
            onRowClick={handleDistributorClick}
          />
        </TabsContent>
      </Tabs>

      {/* Sub-Distributor Dialog */}
      <SubDistributorDialog
        open={showSubDistDialog}
        onOpenChange={setShowSubDistDialog}
        distributor={selectedDistributor}
        isTiered={activeTab === 'tiered'}
      />
    </div>
  );
}

export default CommissionTrackingView;
